<button class="mat-dialog-close" mat-dialog-close>
  <mat-icon svgIcon="close"></mat-icon>
</button>

<!-- Dialog: Header -->
<div class="mat-dialog-header">
  <h2>Login</h2>
  <hr/>
  <small>*Required field</small>
</div>

<!-- Dialog: Content -->
<div class="mat-dialog-body">
  <ecp-login-form></ecp-login-form>
</div>
